<template>
  <v-container fluid>
    <v-layout>
      <v-flex>
        <h2 class="mb-2">Ads Report</h2>
      </v-flex>
    </v-layout>

    <date-filter v-model="selectedDate" @onSelected="getTagSummary"></date-filter>
    <v-layout class="mt-2">
      <v-flex xs12 sm6 class="form-control" style="display: inherit;">
        <div class="input-icons">
          <i class="fa fa-search icon"></i>
          <input type="text" v-model="search" class="form-control" :placeholder="$t('Search')" />
          <v-btn v-show="search.length > 0" @click="clearSearch" icon class="icon-close">
            <i class="fa fa-close"></i
          ></v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on }">
            <div class="text-xs-right">
              <v-btn color="primary" dark v-on="on">
                <i class="fas fa-table mr-2"></i> Select Columns
              </v-btn>
            </div>
          </template>

          <v-card>
            <v-card-text>
              <v-layout>
                <v-flex style="align-self: center;">
                  <h3><i class="fas fa-table mr-2"></i> Columns to analyze</h3>
                </v-flex>
                <v-flex class="text-xs-right">
                  <v-btn flat icon small fab @click="dialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-checkbox
                color="primary"
                hide-details
                v-model="selectedAll"
                @change="onChangeSelectedAll"
              >
                <template v-slot:label><strong>Select all</strong></template></v-checkbox
              >
              <template v-for="(item, index) in headers">
                <v-checkbox
                  :disabled="item.value === 'id' || item.value === 'post'"
                  color="primary"
                  hide-details
                  v-model="selectedHeaders"
                  :label="item.text"
                  :value="item"
                  :key="`header_${index}`"
                ></v-checkbox>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="selectedHeaders"
      :items="filterTagSummary"
      :loading="loading"
      :rows-per-page-items="[50, 100, 200]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <template v-for="(header, index) in selectedHeaders">
          <td
            :style="
              props.item.id.includes('%')
                ? props.item[header.value] > 30
                  ? 'background: red'
                  : 'background: pink'
                : props.item.id === 'All'
                ? 'background: darkseagreen'
                : ''
            "
            v-if="showColumn(header.value)"
            :key="index"
          >
            <a
              v-if="header.value == 'post'"
              :href="props.item[header.value]"
              target="_blank"
              class="primary--text"
              >{{ props.item[header.value] }}</a
            >
            <span v-else>
              {{ props.item[header.value] }}
              {{
                props.item.id.includes('%') &&
                header.text !== 'ads' &&
                header.text !== 'LINK/ โพส,ads'
                  ? '%'
                  : ''
              }}</span
            >
          </td>
        </template>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import dayjs from 'dayjs'
import DateFilter from '@/components/view/analytics/DateFilter'
import AstonAdsDetail from './AstonAdsDetail'
export default {
  data: function() {
    return {
      dialog: false,
      loading: false,
      search: '',
      pageNumber: 1,
      pageCount: 0,
      showsize: 15,
      selectedAll: false,
      selectedHeaders: [],
      headers: [],
      tagSummary: [],
      selectedDate: {
        start: dayjs()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      },
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterTagSummary() {
      const vm = this
      let tagSummary = []
      tagSummary = vm.tagSummary.filter(
        el => el.id && el.id.toLowerCase().includes(vm.search.toLowerCase())
      )
      tagSummary.map(item => {
        if (
          item.id &&
          item.id.includes('percent|') &&
          !item.id.includes('NO_AD') &&
          !item.id.includes('All')
        ) {
          item.id = item.id.replace('percent|', '%post:')
        } else if (item.id.includes('NO_AD')) {
          item.id = item.id.replace('percent|', '%')
        } else {
          if (!item.id.includes('NO_AD') && !item.id.includes('All')) {
            item.post = `https://www.facebook.com/${this.selectedBot.pageid}:${item.id}`
            item.id = `post: ${item.id}`
          }
        }
        item.id = item.id.replace('NO_AD', 'Not ads')
      })
      return tagSummary
    }
  },
  components: {
    DateFilter,
    AstonAdsDetail
  },
  async mounted() {
    const vm = this
    await vm.getTagSummary()
  },
  methods: {
    onChangeSelectedAll() {
      const vm = this
      if (vm.selectedAll) {
        vm.selectedHeaders = vm.headers
      } else {
        vm.selectedHeaders = [
          { text: 'ads', value: 'id' },
          { text: 'LINK/ โพส,ads', value: 'post' }
        ]
      }
    },
    async getTagSummary() {
      const vm = this
      vm.loading = true
      const data = {
        pageId: this.selectedBot.pageid,
        params: {
          from_date: dayjs(vm.selectedDate.start).format('YYYY-MM-DD'),
          to_date: dayjs(vm.selectedDate.end).format('YYYY-MM-DD')
        }
      }
      let response = await api.getTagSummary(data)
      if (response.success && response.result) {
        vm.headers = [
          { text: 'ads', value: 'id' },
          { text: 'LINK/ โพส,ads', value: 'post' }
        ]
        response.table_headers.map(item => {
          vm.headers.push({ text: item, value: item })
        })
        vm.tagSummary = response.result
        if (response.result.length !== 0) {
          vm.tagSummary.push({ id: 'All', ...response.total_tag })
        }
        vm.selectedHeaders = [
          { text: 'ads', value: 'id' },
          { text: 'LINK/ โพส,ads', value: 'post' }
        ]
        if (vm.headers && vm.headers[3]) {
          vm.selectedHeaders.push(vm.headers[2])
        }
        if (vm.headers && vm.headers[4]) {
          vm.selectedHeaders.push(vm.headers[3])
        }
        if (vm.headers && vm.headers[5]) {
          vm.selectedHeaders.push(vm.headers[4])
        }
        vm.loading = false
      }
    },
    clearSearch() {
      const vm = this
      vm.search = ''
    },
    showColumn(col) {
      const vm = this
      return vm.selectedHeaders.find(h => h.value === col)
    }
  }
}
</script>

<style lang="scss" scoped>
.input-icons {
  display: contents;
  i {
    position: absolute;
  }
  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }
  .icon {
    padding: 16px;
    min-width: 50px;
  }
  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AstonTagSummary.vue